import { getKickEndTime, TTimeKick } from '../../../helpers/utils';

export const getKickTimeEnd = (
  kickTime: string,
): { time: string; dateString: TTimeKick } => {
  const dateString = getKickEndTime(kickTime);
  let time = '';
  if (dateString.hours > 0) time += `${dateString.hours} hours`;
  if (dateString.minutes > 0) time += ` ${dateString.minutes} minutes`;
  if (dateString.seconds > 0) time += ` ${dateString.seconds} seconds`;
  return { time, dateString };
};
